export default __webpack_public_path__ + "static/media/podio.9c9f3a0a.svg";